import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/es6.array.find";
import _typeof from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dyOptionsList } from '@/components/Generator/generator/comConfig';
import { getDictionaryDataSelector } from '@/api/systemData/dictionary';
import { previewDataInterface } from '@/api/systemData/dataInterface';
export default {
  name: 'input-table',
  props: {
    config: {
      type: Object,
      default: function _default() {}
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    formData: Object,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tableFormData: [],
      tableData: [],
      isAddRow: true // list类型下 添加行数据 number类型组件会进行校验 产生不需要的结果 在这里进行添加行数据判断 hack
    };
  },
  created: function created() {
    var _this = this;
    this.tableData = this.config.__config__.children;
    this.buildOptions();
    if (this.value && this.value.length) {
      this.value.forEach(function (t) {
        return _this.addRow(t);
      });
    } else {
      this.addRow();
    }
  },
  methods: {
    buildOptions: function buildOptions() {
      this.tableData.forEach(function (cur) {
        var config = cur.__config__;
        if (dyOptionsList.indexOf(config.weforsysKey) > -1) {
          var isTreeSelect = config.weforsysKey === 'treeSelect' || config.weforsysKey === 'cascader';
          if (config.dataType === 'dictionary') {
            if (!config.dictionaryType) return;
            getDictionaryDataSelector(config.dictionaryType).then(function (res) {
              isTreeSelect ? cur.options = res.data.list : cur.__slot__.options = res.data.list;
            });
          }
          if (config.dataType === 'dynamic') {
            if (!config.propsUrl) return;
            previewDataInterface(config.propsUrl).then(function (res) {
              isTreeSelect ? cur.options = res.data : cur.__slot__.options = res.data;
            });
          }
        }
      });
    },
    clearAddRowFlag: function clearAddRowFlag() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.isAddRow = false;
      });
    },
    /**
     * @event cell-click Table 单元格点击事件
     * 点击单元格 聚焦单元格中的input
     */
    focusInput: function focusInput(row, column, cell, event) {
      var child = cell.querySelector('.cell').firstElementChild;
      var input = child && child.querySelector('input');
      input && input.focus();
    },
    onFormDataChange: function onFormDataChange(rowIndex, colIndex, tag) {
      if (this.isAddRow) return;
      var data = this.tableFormData[rowIndex][colIndex];
      data.required && (data.valid = this.checkData(data));
      if (['Weforsys-Amount', 'el-input-number'].includes(tag)) {
        // 金额变动 更新数据 触发计算公式更新
        var newVal = this.tableFormData.map(function (row) {
          return row.reduce(function (p, c) {
            return p[c.__vModel__] = c.value, p;
          }, {});
        });
        this.$emit('input', newVal);
      }
    },
    /**
     * 校验单个表单数据
     * @param {CmpConfig} 组件配置对象
     */
    checkData: function checkData(_ref) {
      var tag = _ref.tag,
        value = _ref.value;
      if ([null, undefined, ''].includes(value)) return false;
      // if (tag === 'org-select') return this.checkOrgData(value)
      if (Array.isArray(value)) return value.length > 0;
      return true;
    },
    /**
     * 对组织机构部门控数据单独校验
     */
    checkOrgData: function checkOrgData(data) {
      var isArray = Array.isArray;
      if (_typeof(data) !== 'object' || isArray(data)) return false;
      var count = 0;
      for (var key in data) {
        count += isArray(data[key]) ? data[key].length : 0;
      }
      return count > 0;
    },
    /**
     * 校验表格数据必填项
     */
    submit: function submit() {
      var _this3 = this;
      var res = true;
      var checkCol = function checkCol(col) {
        return col.required && !_this3.checkData(col) && (res = col.valid = false);
      };
      this.tableFormData.forEach(function (row) {
        return row.forEach(checkCol);
      });
      // console.log(this.tableFormData);
      return res ? this.tableFormData.map(function (row) {
        return row.reduce(function (p, c) {
          return p[c.__vModel__] = c.value, p;
        }, {});
      }) : false;
    },
    /**
     * 根据formid获取完整组件配置
     */
    getConfById: function getConfById(formId) {
      var item = this.tableData.find(function (t) {
        return t.__config__.formId === formId;
      });
      var newObj = {};
      for (var key in item) {
        if (key != '__config__' && key != '__slot__' && key != '__vModel__') {
          newObj[key] = item[key];
        }
        if (key === 'props') {
          newObj[key] = item[key][key];
        }
        if (key === 'disabled') {
          newObj[key] = this.disabled || item[key][key];
        }
      }
      return newObj;
    },
    /**
     * 获取默认行数据
     */
    getEmptyRow: function getEmptyRow(val) {
      return this.tableData.map(function (t) {
        var res = {
          tag: t.__config__.tag,
          formId: t.__config__.formId,
          value: val && val[t.__vModel__] || t.__config__.defaultValue,
          options: t.__slot__ && t.__slot__.options && t.__slot__.options || [],
          // 下拉 单选 多选
          valid: true,
          __vModel__: t.__vModel__,
          required: t.__config__.required
        };
        // if (t.tag === 'el-upload') this.$set(res, 'value', t.defaultValue)
        return res;
      });
    },
    removeRow: function removeRow(index) {
      this.tableFormData.splice(index, 1);
    },
    addRow: function addRow(val) {
      this.isAddRow = true;
      if (!Array.isArray(this.tableFormData)) {
        this.tableFormData = [];
      }
      this.tableFormData.push(this.getEmptyRow(val));
      this.clearAddRowFlag();
    },
    getCmpValOfRow: function getCmpValOfRow(row, key) {
      // 获取数字相关组件的输入值
      var isNumCmp = function isNumCmp(tag) {
        return ['fc-amount', 'el-input-number', 'el-slider'].includes(tag);
      };
      var target = row.find(function (t) {
        return t.vModel === key;
      });
      if (!target) return NaN;
      if (isNumCmp(target.tag)) return target.value || 0;
      return NaN;
    },
    /**
     * 对表格进行合计 目前只支持数字，金额，滑块
     */
    getTableSummaries: function getTableSummaries(param) {
      var _this4 = this;
      var columns = param.columns,
        data = param.data;
      var sums = [];
      if (this.tableData.length + 1 !== columns.length) return []; // 防止多次加载
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        var sumVal = data.reduce(function (sum, d) {
          return sum + _this4.getCmpValOfRow(d, column.property);
        }, 0);
        sums[index] = Number.isNaN(sumVal) ? '' : sumVal;
      });
      return sums;
    },
    resetTable: function resetTable() {
      this.tableData = this.config.__config__.children;
      this.tableFormData = [];
      this.addRow();
    },
    reset: function reset() {
      var _this5 = this;
      this.tableData.map(function (t) {
        var index = _this5.tableFormData[0].findIndex(function (c) {
          return c.vModel === t.vModel;
        });
        if (index === -1) return;
        for (var i = 0; i < _this5.tableFormData.length; i++) {
          _this5.tableFormData[i][index].value = t.defaultValue;
        }
      });
    }
  }
};